<template>
  <div style="border: 1px solid #ccc;" class="wangeditor-container">
    <Toolbar
      style="border-bottom: 1px solid #ccc"
      :editor="editor"
      :default-config="toolbarConfig"
      :mode="mode"
    />
    <Editor
      :value="value"
      style="height: 400px;overflow-y: auto"
      :default-config="editorConfig"
      :mode="mode"
      @input="getColumn"
      @onCreated="onCreated"
    />
  </div>
</template>
<script>
import Vue from "vue";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import request from "@/utils/request";

export default Vue.extend({
  components: { Editor, Toolbar },
  props: {
    value: {
      // 默认文件类型
      type: String,
      default: ""
    }
  },
  data() {
    return {
      editor: null,
      toolbarConfig: {},
      editorConfig: {
        placeholder: "请输入内容...",
        MENU_CONF: {
          // 配置上传图片
          uploadImage: {
            fieldName: "file",
            maxFileSize: 10 * 1024 * 1024,
            server: process.env.VUE_APP_BASE_API + "admin/Resources/wangEditor",
            async customUpload(file, insertFn) {
              const formData = new FormData();
              formData.append("file", file);
              request
                .request({
                  url: "admin/Resources/wangEditor",
                  method: "POST",
                  data: formData
                })
                .then(res => {
                  const url = res.data;
                  insertFn(url, "", url);
                });
            }
          },
          uploadVideo: {
            fieldName: "file",
            maxFileSize: 1024 * 1024 * 1024,
            server: process.env.VUE_APP_BASE_API + "admin/Resources/wangEditor",
            async customUpload(file, insertFn) {
              const formData = new FormData();
              formData.append("file", file);
              request
                .request({
                  url: "admin/Resources/wangEditor",
                  method: "POST",
                  data: formData,
                  timeout: 5 * 60 * 1000
                })
                .then(res => {
                  const url = res.data;
                  insertFn(url, "", url);
                });
            }
          }
        }
      },
      mode: "default" // or 'simple'
    };
  },
  mounted() {
    // 模拟 ajax 请求，异步渲染编辑器
    // setTimeout(() => {
    //   this.html = '<p>模拟 Ajax 异步设置内容 HTML</p>'
    // }, 1500)
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },

  methods: {
    onCreated(editor) {
      // 一定要用 Object.seal() ，否则会报错
      this.editor = Object.seal(editor);
    },
    getColumn(val) {
      if (val === "<p><br></p>") {
        val = "";
      }
      this.$emit("update:value", val);
    }
  }
});
</script>
<style>
.w-e-bar-item button[data-tooltip="全屏"] {
  display: none !important;
}

.wangeditor-container {
  line-height: 1.5;
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
